import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'td-wb-page-content',
  template: '<ng-content />',
  styleUrls: ['page-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageContentComponent {
}
